import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Typography,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const InfoPopup = ({open, onClose, title = "ველის ინფორმაცია", info, hasAddtionalData = false}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            scroll="paper"
        >
            <DialogTitle>
                {title}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    style={{position: 'absolute', right: 8, top: 8}}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent dividers style={{padding: '20px', maxHeight: '80vh'}}>
                <Typography variant="body1" component="p">
                    {info}
                </Typography>
                {
                    hasAddtionalData && (
                        <>
                            <div>
                                მაგალითად:
                            </div>
                            <div>
                                ❌ www.example.com – არასწორია
                            </div>
                            <div>
                                ✅ https://www.example.com – სწორია
                            </div>
                        </>
                    )
                }
            </DialogContent>
        </Dialog>
    );
};

export default InfoPopup;
